import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import WolfMark from "@/components/WolfMark";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) {
      const to = loc.state?.from || "/den";
      nav(to, { replace: true });
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080808] px-6 pt-28 pb-16" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <WolfMark className="w-10 h-10" />
          <p className="font-display tracking-extreme text-white text-2xl">WOLF</p>
        </div>
        <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]/90">— Sign in</p>
        <h1 className="font-display text-5xl sm:text-6xl text-white mt-3 leading-[0.9]">Enter The Den.</h1>
        <p className="font-editorial italic text-white/55 mt-3">Welcome back. The floor is yours.</p>

        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.32em] text-white/60">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition"
              placeholder="you@wolf.com"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.32em] text-white/60">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition"
            />
          </div>

          {err && <p className="text-sm text-red-300" data-testid="login-error">{err}</p>}

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-btn"
            className="w-full font-display tracking-extreme text-sm bg-transparent text-[#D4AF37] border border-[#D4AF37]/70 px-6 py-4 hover:bg-[#D4AF37] hover:text-black hover:border-[#D4AF37] transition-colors disabled:opacity-40"
          >
            {busy ? "Tracking…" : "Sign In"}
          </button>
        </form>

        <p className="mt-8 text-[11px] uppercase tracking-[0.28em] text-white/55">
          New to the pack?{" "}
          <Link to="/register" data-testid="login-register-link" className="text-white hover:text-[#D4AF37] underline underline-offset-4">
            Join The Pack
          </Link>
        </p>
      </div>
    </div>
  );
}
